import React, {useCallback} from 'react';

type KeyDownHandlerParams = {
	onAction: (...args: any[]) => void;
	keys?: string[];
};

const useKeyDownHandler = ({ onAction, keys = ['Enter', ' '] }: KeyDownHandlerParams) => {
	return useCallback(
		(event: React.KeyboardEvent<HTMLDivElement>, ...args: any[]) => {
			if (keys.includes(event.key)) {
				event.preventDefault();
				onAction(...args);
			}
		},
		[onAction, keys]
	);
};

export default useKeyDownHandler;